import { createFileRoute } from "@tanstack/react-router";
import { CreateTeammate } from "@/features/teammates";

const Route = createFileRoute("/_authorized/teammates/create/")({
  component: () => <CreateTeammate />,
});

export { Route };
